import { HasId } from "app/shared/model/properties.model";

export interface GeneralParameters {
    [key:string]: any,
    id?: number | number[],
    sort?: string | string[],
    size?: number,
    page?: number,
    projection?: string | BaseProjections
}

export interface HasLogRequest extends GeneralParameters {
    log?: string | number
}

export interface ReferencesLogRequest extends GeneralParameters {
    logId?: string | number
}

export interface BaseEntityProjectionType {
    [BaseProjections.IdProjection]: HasId
}

export interface HasUserDetails extends GeneralParameters {
    userDetails?: string | number
}

export enum BaseProjections {
    IdProjection = 'idProjection'
}

export enum NotificationProjections {
    withLogName = 'notificationProjectionWithLogName'
}

export enum NoteProjections {
    BASE = 'noteProjection',
    onsite = 'noteProjectionOnsite',
    sentinel = 'noteProjectionSentinel',
    fastTemplateValues = 'noteProjectionWithFastTemplateValues',
    templateValues = 'noteProjectionWithTemplateValues',
    keyTemplateValues = 'noteProjectionWithKeyNoteTemplateValues'
}

export enum NoteCommentProjections {
    onsite = 'noteCommentProjectionOnsite',
}

export enum AlertEventProjections {
    detailed = 'alertEventProjectionDetailed'
}

export enum LogProjections {
    withLogOwnerUser = 'logProjectionWithLogOwnerUser'
}

export enum TemplateProjections {
    BASE = 'templateProjection',
    WITH_USERS = 'templateProjectionWithUsers',
    WITH_SUB_TEMPLATES = 'templateProjectionWithSubTemplates'
}

export enum FileAttachmentProjections {
    BASE = 'fileAttachmentProjection'
}

export enum LogUserProjections {
    BASE = 'logUserProjection',
    WITH_LOG = 'logUserProjectionWithLog'
}

export class Projections {
    public static readonly Default = BaseProjections
    public static readonly Notes = NoteProjections
    public static readonly NoteComment = NoteCommentProjections
    public static readonly Notifications = NotificationProjections
    public static readonly AlertEvent = AlertEventProjections
    public static readonly Logs = LogProjections
    public static readonly Template = TemplateProjections
    public static readonly FileAttachment = FileAttachmentProjections
    public static readonly LogUser = LogUserProjections
}